var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "28px",
    viewBox: "0 0 50 28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.999 0L46.001 0Q46.1975 0 46.393 0.0192563Q46.5885 0.0385126 46.7812 0.0768396Q46.9738 0.115167 47.1618 0.172196Q47.3498 0.229224 47.5313 0.304406Q47.7128 0.379587 47.8861 0.472197Q48.0594 0.564807 48.2227 0.673953Q48.3861 0.783099 48.5379 0.907731Q48.6898 1.03236 48.8287 1.17128Q48.9676 1.3102 49.0923 1.46206Q49.2169 1.61393 49.326 1.77727Q49.4352 1.94062 49.5278 2.11388Q49.6204 2.28715 49.6956 2.46865Q49.7708 2.65015 49.8278 2.83815Q49.8848 3.02615 49.9232 3.21883Q49.9615 3.41152 49.9807 3.60703Q50 3.80254 50 3.999L50 24.001Q50 24.1975 49.9807 24.393Q49.9615 24.5885 49.9232 24.7812Q49.8848 24.9738 49.8278 25.1618Q49.7708 25.3498 49.6956 25.5313Q49.6204 25.7129 49.5278 25.8861Q49.4352 26.0594 49.326 26.2227Q49.2169 26.3861 49.0923 26.5379Q48.9676 26.6898 48.8287 26.8287Q48.6898 26.9676 48.5379 27.0923Q48.3861 27.2169 48.2227 27.326Q48.0594 27.4352 47.8861 27.5278Q47.7129 27.6204 47.5313 27.6956Q47.3499 27.7708 47.1618 27.8278Q46.9739 27.8848 46.7812 27.9232Q46.5885 27.9615 46.393 27.9807Q46.1975 28 46.001 28L3.999 28Q3.80254 28 3.60703 27.9807Q3.41152 27.9615 3.21883 27.9232Q3.02615 27.8848 2.83815 27.8278Q2.65015 27.7708 2.46865 27.6956Q2.28715 27.6204 2.11388 27.5278Q1.94062 27.4352 1.77727 27.326Q1.61393 27.2169 1.46206 27.0923Q1.3102 26.9676 1.17128 26.8287Q1.03236 26.6898 0.907731 26.5379Q0.783099 26.3861 0.673953 26.2227Q0.564807 26.0594 0.472197 25.8861Q0.379587 25.7129 0.304406 25.5313Q0.229224 25.3498 0.172196 25.1618Q0.115167 24.9738 0.0768396 24.7812Q0.0385126 24.5885 0.0192563 24.393Q0 24.1975 0 24.001L0 3.999Q0 3.80254 0.0192563 3.60703Q0.0385126 3.41152 0.0768396 3.21883Q0.115167 3.02615 0.172196 2.83815Q0.229224 2.65015 0.304406 2.46865Q0.379587 2.28715 0.472197 2.11388Q0.564807 1.94062 0.673953 1.77727Q0.783099 1.61393 0.907731 1.46206Q1.03236 1.3102 1.17128 1.17128Q1.3102 1.03236 1.46206 0.907731Q1.61393 0.783099 1.77727 0.673953Q1.94062 0.564807 2.11388 0.472197Q2.28715 0.379587 2.46865 0.304406Q2.65015 0.229224 2.83815 0.172196Q3.02615 0.115167 3.21883 0.0768396Q3.41152 0.0385126 3.60703 0.0192563Q3.80254 0 3.999 0Z",
    id: "Rectangle-10",
    fill: "#EAF0FB",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(2 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 12.7259L17.5332 0.410156L20.8666 0.410156L18.7999 12.7259L15.3999 12.7259Z",
    id: "Polygon",
    fill: "#00579F",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8665 0.547368C30.1998 0.273684 29.1332 0 27.7998 0C24.4665 0 22.0665 1.71053 22.0665 4.17368C22.0665 6.02105 23.7332 6.97895 25.0665 7.59474C26.3998 8.21053 26.7998 8.62105 26.7998 9.16842C26.7998 9.98948 25.7332 10.4 24.7998 10.4C23.4665 10.4 22.7332 10.1947 21.5998 9.71579L21.1332 9.51053L20.6665 12.3158C21.4665 12.6579 22.9332 13 24.4665 13C27.9998 13 30.3332 11.2895 30.3332 8.68947C30.3332 7.25263 29.4665 6.1579 27.4665 5.26842C26.2665 4.65263 25.5332 4.31053 25.5332 3.69474C25.5332 3.14737 26.1332 2.6 27.4665 2.6C28.5998 2.6 29.3998 2.80526 29.9998 3.07895L30.3332 3.21579L30.8665 0.547368L30.8665 0.547368L30.8665 0.547368Z",
    id: "Shape",
    fill: "#00579F",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 0.410156C35.8 0.410156 35.2 0.478578 34.8667 1.29963L29.8667 12.7259L33.4667 12.7259L34.1334 10.6733L38.4 10.6733L38.8 12.7259L42 12.7259L39.2 0.410156L36.6 0.410156L36.6 0.410156ZM35.0669 8.62059C35.2669 8.0048 36.4002 4.99427 36.4002 4.99427C36.4002 4.99427 36.6669 4.24164 36.8669 3.7627L37.0669 4.92585C37.0669 4.92585 37.7336 8.0048 37.8669 8.68901L35.0669 8.68901L35.0669 8.62059L35.0669 8.62059Z",
    id: "Shape",
    fill: "#00579F",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26661 9.03115L8.93327 7.2522C8.33327 5.19957 6.39994 2.94167 4.2666 1.84694L7.2666 12.7943L10.8666 12.7943L16.2666 0.478516L12.6666 0.478516L9.26661 9.03115L9.26661 9.03115Z",
    id: "Shape",
    fill: "#00579F",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.410156L0.600001 0.546999C4.86667 1.57331 7.80001 4.17331 8.93334 7.25226L7.73334 1.43647C7.53334 0.615419 6.93334 0.410156 6.20001 0.410156L0 0.410156L0 0.410156Z",
    id: "Shape",
    fill: "#FFBC00",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.410156L0 0.410156C4.26667 1.43647 7.80001 4.10489 8.93334 7.18384L7.80001 2.32594C7.60001 1.50489 6.93334 1.02594 6.20001 1.02594L0 0.410156L0 0.410156Z",
    id: "Shape",
    fill: "#FAA61A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.410156L0 0.410156C4.26667 1.43647 7.80001 4.10489 8.93334 7.18384L8.13334 4.51542C7.93334 3.69436 7.66667 2.87331 6.73334 2.53121L0 0.410156L0 0.410156Z",
    id: "Shape",
    fill: "#ED7C00",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.80ce056d936bd9bec8b2d111e5845b6a.svg";
export { ForwardRef as ReactComponent };